import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { mergeAll, tap } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { Department } from '../../models/department';
import { DepartmentDataSource } from '../../data-sources/department.data-source';
import { DepartmentService } from '../../services/department.service';
import { IBreadcrumbData } from '../../../../interfaces/breadcrumb-data.interface';
import { SimpleDialogService } from '../../../../services/simple-dialog.service';
import { DepartmentEditComponent } from '../../components/departments/edit/edit.component';
import { SimpleDialogData } from '../../../../interfaces/simple-dialog-data.interface';
import { of } from 'rxjs';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'departments',
  templateUrl: './departments.component.html',
  styleUrls: ['./departments.component.scss'],
})
export class DepartmentsComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ['description', 'emails', 'mobiles', 'action'];

  /**
   * Table config array
   */
  tableConfig: any[] = [
    {
      columnName: 'departamento',
    },
    {
      columnName: 'emails',
    },
    {
      columnName: 'móviles',
    },
    '',
  ];

  /**
   * BreadcrumbData
   */
  breadcrumbData: IBreadcrumbData;

  /**
   * MasterVehicle data source
   */
  departmentsDataSource: DepartmentDataSource;

  /**
   * Paginator
   */
  @ViewChild(MatPaginator) paginator: MatPaginator;

  /**
   * Sort
   */
  @ViewChild(MatSort) sort: MatSort;

  /**
   * Filter object
   */
  filter: any;

  /**
   * Count of total departments
   */
  totalDepartments: number;

  constructor(private departmentService: DepartmentService, public dialog: MatDialog, private simpleDialogService: SimpleDialogService) {
    this.breadcrumbData = {
      titles: {
        icon: 'directions_car',
        links: [
          {
            text: 'Lista Departamentos',
          },
        ],
      },
      buttons: [
        {
          text: 'Crear',
          action: () => this.create(),
          icon: 'add',
          disabled: false
        },
      ],
    };
  }

  ngOnInit(): void {
    this.departmentsDataSource = new DepartmentDataSource(this.departmentService);
    this.departmentsDataSource.load();
    this.departmentService.getCount().subscribe((data: { count: number }) => (this.totalDepartments = data.count));
  }

  /**
   * ngAfterViewInit
   */
  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));

    of(this.sort.sortChange, this.paginator.page)
      .pipe(
        mergeAll(),
        tap(() => this.loadDepartments())
      )
      .subscribe();
  }

  /**
   * Load departments
   */
  loadDepartments(): void {
    this.departmentsDataSource.load(this.sort.active, this.sort.direction, this.paginator.pageSize, this.paginator.pageIndex, this.filter);

    this.departmentService
      .getCount('description', this.sort.direction, this.paginator.pageSize, this.paginator.pageIndex, this.filter)
      .subscribe((data: { count: number }) => (this.totalDepartments = data.count));
  }

  /**
   * Create
   */
  create(): void {
    const dialogRef = this.dialog.open(DepartmentEditComponent, { width: '450px', disableClose: true });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.loadDepartments();
      }
    });
  }

  /**
   * Edit
   *
   * @param department Department instance
   */
  edit(department: Department): void {
    const dialogRef = this.dialog.open(DepartmentEditComponent, {
      width: '450px',
      disableClose: true,
      data: {
        departmentId: department.id,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.loadDepartments();
      }
    });
  }

  /**
   * Remove
   *
   * @param department Department instance
   */
  remove(department: Department): void {
    const data: SimpleDialogData = {
      title: 'Warning!',
      message: `Quieres eliminar el departamento ${department.description}?`,
      rightButtonText: 'Yes',
    };

    this.simpleDialogService.open(data).subscribe((response) => {
      if (response) {
        this.departmentService.delete(department.id).subscribe(() => this.loadDepartments());
      }
    });
  }
}
